/* PricingCalculatorSkeleton.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"],
  _excluded6 = ["as", "style"],
  _excluded7 = ["as", "style"],
  _excluded8 = ["as", "style"],
  _excluded9 = ["as", "style"],
  _excluded10 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _32 = "@media not all and (min-width:64rem){._1mjb1ule{display:block}._1s4p1ra4{width:var(--_15e4x58)}}";
const _31 = "._1e0cglyw{display:none}";
const _30 = "._1bsb1rkg{width:var(--_1gljcou)}";
const _29 = "@media not all and (min-width:64rem){._8fz615ab{max-width:26.25rem}._na0i1bp4{flex-direction:column}._dh1a1h6o{align-items:center}}";
const _28 = "._1bah1h6o{justify-content:center}";
const _27 = "._x3dozgxb{border-top:1px solid var(--ds-border,#091e4224)}";
const _26 = "._1yt4pxbi{padding:var(--ds-space-200,1pc)}";
const _25 = "@media not all and (min-width:64rem){._dh1a1h6o{align-items:center}}";
const _24 = "._1bsb1ssb{width:50%}";
const _23 = "@media not all and (min-width:64rem){._na0i1bp4{flex-direction:column}._dh1a1h6o{align-items:center}._1kne1f8t{height:11.875rem}}";
const _22 = "._n3tdxy5q{padding-bottom:var(--ds-space-400,2pc)}";
const _21 = "._ca0qxy5q{padding-top:var(--ds-space-400,2pc)}";
const _20 = "@media not all and (min-width:64rem){._pffpzgxb{border-bottom:1px solid var(--ds-border,#091e4224)}._dh1a1h6o{align-items:center}._1hwcxy5q{padding-bottom:var(--ds-space-400,2pc)}._1s4p1osq{width:100%}}";
const _19 = "._1bsbhv4l{width:65%}";
const _18 = "._1bsb1vuk{width:90%}";
const _17 = "@media not all and (min-width:64rem){._1s4p1osq{width:100%}}";
const _16 = "._4cvr1h6o{align-items:center}";
const _15 = "._4t3i1f8t{height:11.875rem}";
const _14 = "._1bsb1r5k{width:30%}";
const _13 = "@media not all and (min-width:64rem){._na0i1bp4{flex-direction:column}._8fz615ab{max-width:26.25rem}}";
const _12 = "._1bsb1osq{width:100%}";
const _11 = "._1bah1yb4{justify-content:space-between}";
const _10 = "._1yt4xy5q{padding:var(--ds-space-400,2pc)}";
const _9 = "._zulp1ejb{gap:var(--ds-space-300,24px)}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { media } from '@atlaskit/primitives/responsive';
import { Stripe } from '@atlassian/mpac-primitives';
import React from 'react';
import { PricingDescription } from '../PricingTab.styles';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const _8 = "@media not all and (min-width:64rem){._na0i1bp4{flex-direction:column}._dh1a1h6o{align-items:center}}";
const _7 = "._p12f4okr{max-width:55.625rem}";
const _6 = "._2lx21bp4{flex-direction:column}";
const _5 = "._1e0c1txw{display:flex}";
const _4 = "._2rko1crf{border-radius:9pt}";
const _3 = "._19itzgxb{border:1px solid var(--ds-border,#091e4224)}";
const _2 = "._18s81mxl{margin:var(--ds-space-250,20px) auto}";
const _ = "._zulpv47k{gap:var(--ds-space-250,20px)}";
const PricingCalculatorSkeletonComponent = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6, _7, _8]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_zulpv47k _18s81mxl _19itzgxb _2rko1crf _1e0c1txw _2lx21bp4 _p12f4okr _na0i1bp4 _dh1a1h6o", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  PricingCalculatorSkeletonComponent.displayName = 'PricingCalculatorSkeletonComponent';
}
const PricingCalculatorContentSkeleton = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_9, _10, _5, _11, _12, _13]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_zulp1ejb _1yt4xy5q _1e0c1txw _1bah1yb4 _1bsb1osq _na0i1bp4 _8fz615ab", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  PricingCalculatorContentSkeleton.displayName = 'PricingCalculatorContentSkeleton';
}
const PricingDisplaySkeleton = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_14, _15, _5, _6, _11, _16, _17]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1bsb1r5k _4t3i1f8t _1e0c1txw _2lx21bp4 _1bah1yb4 _4cvr1h6o _1s4p1osq", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  PricingDisplaySkeleton.displayName = 'PricingDisplaySkeleton';
}
const UserInputContainer = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_18, _5, _11, _8]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1bsb1vuk _1e0c1txw _1bah1yb4 _na0i1bp4 _dh1a1h6o", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  UserInputContainer.displayName = 'UserInputContainer';
}
const UserCountContainerSkeleton = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_5, _6, _19, _20]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _2lx21bp4 _1bsbhv4l _pffpzgxb _dh1a1h6o _1hwcxy5q _1s4p1osq", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  UserCountContainerSkeleton.displayName = 'UserCountContainerSkeleton';
}
const TextFieldSkeleton = forwardRef((_ref6, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref6,
    __cmplp = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_12, _5, _11, _21, _22, _23]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1bsb1osq _1e0c1txw _1bah1yb4 _ca0qxy5q _n3tdxy5q _na0i1bp4 _dh1a1h6o _1kne1f8t", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  TextFieldSkeleton.displayName = 'TextFieldSkeleton';
}
const RadioInputContainerSkeleton = forwardRef((_ref7, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref7,
    __cmplp = _objectWithoutProperties(_ref7, _excluded7);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_24, _5, _11, _25]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1bsb1ssb _1e0c1txw _1bah1yb4 _dh1a1h6o", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  RadioInputContainerSkeleton.displayName = 'RadioInputContainerSkeleton';
}
export const PricingCalculatorFooterSkeleton = forwardRef((_ref8, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref8,
    __cmplp = _objectWithoutProperties(_ref8, _excluded8);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_26, _27, _12, _5, _28, _29]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1yt4pxbi _x3dozgxb _1bsb1osq _1e0c1txw _1bah1h6o _8fz615ab _na0i1bp4 _dh1a1h6o", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  PricingCalculatorFooterSkeleton.displayName = 'PricingCalculatorFooterSkeleton';
}
export const StripeSkeleton = forwardRef((_ref9, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref9,
    __cmplp = _objectWithoutProperties(_ref9, _excluded9);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_30, _17]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: _objectSpread(_objectSpread({}, __cmpls), {}, {
        "--_1gljcou": ix(__cmplp.width)
      }),
      ref: __cmplr,
      className: ax(["_1bsb1rkg _1s4p1osq", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  StripeSkeleton.displayName = 'StripeSkeleton';
}
export const MobileStripeSkeleton = forwardRef((_ref10, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref10,
    __cmplp = _objectWithoutProperties(_ref10, _excluded10);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_31, _32]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: _objectSpread(_objectSpread({}, __cmpls), {}, {
        "--_15e4x58": ix(__cmplp.width || '100%')
      }),
      ref: __cmplr,
      className: ax(["_1e0cglyw _1mjb1ule _1s4p1ra4", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  MobileStripeSkeleton.displayName = 'MobileStripeSkeleton';
}
const PricingCalculatorSkeleton = _ref11 => {
  let {
    showServerEolMessage
  } = _ref11;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!showServerEolMessage ? /*#__PURE__*/_jsx(PricingDescription, {
      children: /*#__PURE__*/_jsx(Stripe, {
        height: "1rem",
        width: "60%",
        marginTop: "var(--ds-space-200, 16px)"
      })
    }) : null, /*#__PURE__*/_jsxs(PricingCalculatorSkeletonComponent, {
      children: [/*#__PURE__*/_jsxs(PricingCalculatorContentSkeleton, {
        children: [/*#__PURE__*/_jsxs(UserCountContainerSkeleton, {
          children: [/*#__PURE__*/_jsx(Stripe, {
            height: "1rem",
            width: "60%",
            marginTop: "var(--ds-space-200, 16px)"
          }), /*#__PURE__*/_jsxs(UserInputContainer, {
            children: [/*#__PURE__*/_jsx(StripeSkeleton, {
              width: "40%",
              children: /*#__PURE__*/_jsx(Stripe, {
                height: "1.5rem",
                width: "100%",
                marginTop: "var(--ds-space-400, 32px)"
              })
            }), /*#__PURE__*/_jsxs(RadioInputContainerSkeleton, {
              children: [/*#__PURE__*/_jsx(Stripe, {
                height: "1.5rem",
                width: "45%",
                marginTop: "var(--ds-space-400, 32px)"
              }), /*#__PURE__*/_jsx(Stripe, {
                height: "1.5rem",
                width: "45%",
                marginTop: "var(--ds-space-400, 32px)"
              })]
            })]
          }), /*#__PURE__*/_jsxs(TextFieldSkeleton, {
            children: [/*#__PURE__*/_jsx(Stripe, {
              height: "0.875rem",
              width: "78%",
              marginTop: "var(--ds-space-250, 20px)"
            }), /*#__PURE__*/_jsx(MobileStripeSkeleton, {
              width: "50%",
              children: /*#__PURE__*/_jsx(Stripe, {
                height: "0.875rem",
                width: "100%",
                marginTop: "var(--ds-space-100, 8px)"
              })
            }), /*#__PURE__*/_jsx(Stripe, {
              height: "2.5rem",
              width: "5.625rem",
              marginTop: "var(--ds-space-100, 8px)"
            })]
          })]
        }), /*#__PURE__*/_jsxs(PricingDisplaySkeleton, {
          children: [/*#__PURE__*/_jsx(Stripe, {
            height: "0.875rem",
            width: "40%"
          }), /*#__PURE__*/_jsx(Stripe, {
            height: "0.875rem",
            width: "40%",
            marginTop: "var(--ds-space-400, 32px)"
          }), /*#__PURE__*/_jsx(Stripe, {
            height: "2.5rem",
            width: "60%",
            marginTop: "var(--ds-space-600, 48px)"
          })]
        })]
      }), /*#__PURE__*/_jsxs(PricingCalculatorFooterSkeleton, {
        children: [/*#__PURE__*/_jsx(Stripe, {
          height: "0.875rem",
          width: "80%"
        }), /*#__PURE__*/_jsx(MobileStripeSkeleton, {
          width: "50%",
          children: /*#__PURE__*/_jsx(Stripe, {
            height: "0.875rem",
            width: "100%",
            marginTop: "var(--ds-space-100, 8px)"
          })
        })]
      })]
    })]
  });
};
export default PricingCalculatorSkeleton;